import styled from 'styled-components';

const ProfileContainer = styled.div`
  padding: 20px;
`;

const SkillContainer = styled.div`
  .skill-inputs {
    display: grid;
    grid-template-columns: 53% 21% 20%;
    align-items: center;
    justify-content: space-between;
  }
  @media only screen and (max-width: 600px) {
    .skill-inputs {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      > div {
        &:nth-child(1) {
          width: 49%;
          margin-right: 2%;
        }
        &:nth-child(2) {
          width: 49%;
        }
      }
    }
  }
  .add-icon {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
    bottom: -14px;
  }
  .skill-content {
    min-height: 160px;
    font-size: 15px;
    margin-top: 16px;
  }
  .show-skills {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 6px 0;
  }
  .profile-show-skills {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    .MuiChip-root {
      font-size: 14.5px;
      background-color: ${({ theme }) => theme.mode === 'light' ? '#f3f3f3' : '#292929'}; 
    }
  }
  .icon-action {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      margin: 0 10px;
      cursor: pointer;
      font-size: 16px;
    }
    .edit-icon {
      cursor: pointer;
      > button {
        fill: #1976d2;
      }
    }
    .remove-icon {
      cursor: pointer;
      > button {
        fill: red;
      }
    }
    .form-drag-icon {
      cursor: grab;
      svg {
        fill: ${({ theme }) => theme.svg1};
      }
    }
  }
`;

const SubmitContainer = styled.div`
  padding-top: 8px;
  text-align: end;
  .add-new {
    margin: 0 8px;
    svg path {
      fill: #1976D2;
    }
  }
  &.addmore-btn, &.company-btn {
    padding-top: 24px;
  }
`;

const ExperienceContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .profile-experience-container {
    width: 100%;
  }
  .field-wrap {
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
    > div {
      width: 48%;
    }
  }
  .exp-inputs {
    margin-top: 8px;
    .ql-container {
      height: 200px;
    }
  }
  .date-container {
    margin-top: 8px;
    label {
      font-size: 14px;
    }
    .date-select-field {
      display: flex;
      justify-content: space-between;
      > div {
        width: 48%;
      }
    }
    .errMsg {
      display: inline-flex;
      white-space: nowrap;
    }
  }
`;

const ExperienceList = styled.div`
  width: 100%;
  font-size: 15px;
  .show-exp-list {
    position: relative;
    border-bottom: 1px solid ${({ theme }) => theme.border1};
    padding: 8px 0px;
    &:last-child {
      border: 0;
    }
    .icon-action {
      position: absolute;
      top: 4px;
      right: 0px;
      display: flex;
      justify-content: center;
      .edit-icon {
        margin-right: 5px;
        > button {
          fill: #1976d2;
        }
      }
      .remove-icon {
        > button {
          fill: red;
        }
      }
    }
  }
  .exp-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80%;
  }
  .exp-list-title {
    width: 100%;
  }
  .role {
    font-size: 16px;
    font-weight: 500;
  }
  .exp-date {
    font-size: 13px;
    font-style: italic;
  }
  .sub-data {
    margin-top: 4px;
    color: ${({ theme }) => theme.fieldText1};
  }
  .sub-data-flex {
    margin-top: 4px;
    display: flex;
    flex-wrap: wrap;
    span {
      color: #a0a0a0;
      margin: 0 4px;
    }
  }
  .degree-container {
    color: ${({ theme }) => theme.fieldText1};
  }
`;
const AddMorelist = styled.div`
  .addmore-list-container {
    margin-bottom: 12px;
    color: ${({ theme }) => theme.text1};
    border: 1px solid ${({ theme }) => theme.border1};
    border-radius: 10px;
    font-size: 15px;
    position: relative;
    padding: 8px;
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .card-title {
      font-size: 15px;
      font-weight: 600;
      width: 85%;
      margin-bottom: 8px;
    }
    .header-icons {
      position: absolute;
      right: 7px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        margin: 0 10px;
        font-size: 16px;
      }
      .edit-icon {
        > button {
          fill: #6c6c6c;
        }
      }
      .remove-icon {
        > button {
          fill: red;
        }
      }
    }
  }
.addmore-list-image {
  text-align: center;
  border-radius: 4px;
  padding: 6px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  img {
    max-width: 100%;
    max-height: 300px;
    border-radius: 2px;
  }
}
.add-more-section-btn {
  text-align: end;
  .MuiButton-startIcon {
    width: 24px;
    margin-left: 0;
    margin-right: 0;
  }
}
`

const Education = styled.div`
  h4 {
    color: grey;
    font-size: 12px;
  }
  .role {
    font-size: 15px;
    font-weight: 500;
  }
  .institute {
    font-size: 13px;
  }
`;

const PersonalContainer = styled.div`
  .inputContainer,
  .text-editor,
  .selectContainer {
    margin-top: 12px;
  }
  .ql-container {
    height: 250px;
  }
  .date-container {
    margin: 12px 0;
    label {
      font-size: 15px;
    }
    .date-select-field {
      display: flex;
      justify-content: space-between;
      > div {
        width: 30%;
      }
    }
  }
  .company-date-container {
    margin: 12px 0;
    label {
      font-size: 15px;
    }
    .date-select-field {
      display: flex;
      justify-content: space-between;
      > div {
        width: 30%;
      }
      .selectContainer {
        margin-top: 0px;
      }
    }
  }
  .field-wrap {
    display: flex;
    justify-content: space-between;
    height: fit-content;
    > div {
      width: 47.5%;
    }
  }
  .personal-email-block {
    margin-top: 12px;
  }
`;

const MainProfileContainer = styled.div`
  .loader-container {
    height: 50vh;
  }
  .profile-pic {
    text-align: center;
    width: 100%;
    img {
      object-fit: contain;
      width: 100%;
      height: 250px;
    }
  }
`;
const SubProfileContainer = styled.div`
  padding: 24px;
  .profile-pic {
    text-align: center;
  }
`;

const PersonalInfo = styled.div`
  padding: 24px;
`;

const NoProfile = styled.div`
  text-align: center;
  margin-top: 40px;
`;

const ProfileLoaderContainer = styled.div`
  height: 70vh;
`;

export {
  ProfileContainer,
  SkillContainer,
  ExperienceContainer,
  ExperienceList,
  Education,
  SubmitContainer,
  PersonalContainer,
  MainProfileContainer,
  SubProfileContainer,
  PersonalInfo,
  AddMorelist,
  NoProfile,
  ProfileLoaderContainer
};
